import { render, staticRenderFns } from "./PersistMotoristaView.vue?vue&type=template&id=5f09605c&"
import script from "./PersistMotoristaView.vue?vue&type=script&lang=ts&"
export * from "./PersistMotoristaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports